var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5394 21.1976C17.4507 22.253 16.2619 22.0864 15.1176 21.5864C13.9067 21.0754 12.7957 21.0532 11.5181 21.5864C9.91829 22.2752 9.07395 22.0752 8.11852 21.1976C2.69698 15.6094 3.49688 7.09936 9.65166 6.78828C11.1515 6.86605 12.1958 7.6104 13.0734 7.67706C14.3844 7.41043 15.6398 6.64386 17.0396 6.74385C18.7172 6.87716 19.9837 7.54374 20.8169 8.74359C17.3507 10.8211 18.1728 15.3872 21.3502 16.6648C20.7169 18.3313 19.8948 19.9866 18.5283 21.2087L18.5394 21.1976ZM12.9624 6.72163C12.7957 4.24416 14.8066 2.19997 17.1174 2C17.4396 4.8663 14.5177 6.99937 12.9624 6.72163Z",
    fill: "#0C1525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.cbe54dcde6930c7ab7cae7918d895d93.svg";
export { ForwardRef as ReactComponent };